import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import LoginRequiredBuffer from '../../components/LoginRequiredBuffer';
import HelpSupportPage from './index';

const HelpSupportWrapper = () => {
  const { user } = useAuth();

  // Show login buffer if not authenticated
  if (!user) {
    return <LoginRequiredBuffer />;
  }

  // Show help support page if authenticated
  return <HelpSupportPage />;
};

export default HelpSupportWrapper;
